var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVehicleDashboardIconActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 9.375H18.75",
    stroke: "#3174A4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.375V16.25C17.5 16.4158 17.4342 16.5747 17.3169 16.6919C17.1997 16.8092 17.0408 16.875 16.875 16.875H15C14.8342 16.875 14.6753 16.8092 14.5581 16.6919C14.4408 16.5747 14.375 16.4158 14.375 16.25V14.375",
    stroke: "#3174A4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 14.375V16.25C5.625 16.4158 5.55915 16.5747 5.44194 16.6919C5.32473 16.8092 5.16576 16.875 5 16.875H3.125C2.95924 16.875 2.80027 16.8092 2.68306 16.6919C2.56585 16.5747 2.5 16.4158 2.5 16.25V14.375",
    stroke: "#3174A4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.875H6.25",
    stroke: "#3174A4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11.875H15",
    stroke: "#3174A4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.375L15.1641 4.125C15.1156 4.01393 15.0359 3.91935 14.9346 3.85277C14.8334 3.78619 14.7149 3.75049 14.5938 3.75H5.40625C5.28507 3.75049 5.16664 3.78619 5.06538 3.85277C4.96413 3.91935 4.88441 4.01393 4.83594 4.125L2.5 9.375V14.375H17.5V9.375Z",
    stroke: "#3174A4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleDashboardIconActive);
export default __webpack_public_path__ + "static/media/VehicleDashboardIconActive.4dfb109a1f843e1052847788b10a75b6.svg";
export { ForwardRef as ReactComponent };